import { Navigate, useParams } from "react-router-dom-v5-compat";

export const RegionRedirect = () => {
  const { region } = useParams<{ region: string }>();

  return <Navigate to={`/crm/regions/region/${region}`} replace />;
};
